export default "__VITE_ASSET__DO_BTXQi__"